// Parwin Wet Line cart upsell: one-tap add + option picker + "Added" confirmation (2.5 s).
// The state span inside each button has data-skip-node-update so the theme's cart re-render keeps it (no flicker).
// Rendered by snippets/parwin-wetline-upsell.liquid; loaded from layout/theme.liquid.
(function () {
  if (window.__ppWlBound) return;
  window.__ppWlBound = true;

  var ADDED_MS = 2500;
  var MIN_TICK_MS = 650; // the tick is seen this long before the cart updates
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var added = new Map(); // product id -> time the tick should clear

  // Keep the band where it is on screen while the cart re-renders after an add. The new line
  // goes in above the band and would push it down (the free-gift script re-renders again about
  // a second later), so the drawer is scrolled by the same amount before the frame is painted.
  var hold = null; // { top, until }
  function scrollerOf(el) {
    el = el.parentElement;
    while (el && el !== document.body) {
      var o = getComputedStyle(el).overflowY;
      if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return null;
  }
  function holdBand() {
    var band = document.querySelector('.pp-wl');
    hold = band ? { top: band.getBoundingClientRect().top, until: Date.now() + 6000 } : null;
  }
  function keepBand() {
    if (!hold) return;
    if (Date.now() > hold.until) { hold = null; return; }
    var band = document.querySelector('.pp-wl');
    if (!band) return;
    var delta = band.getBoundingClientRect().top - hold.top;
    if (Math.abs(delta) < 1) return;
    var s = scrollerOf(band);
    if (!s) return;
    s.scrollTop += delta;
    hold.top = band.getBoundingClientRect().top;
  }

  // The drawer is re-rendered after every cart change, which replaces the button
  // nodes. Re-apply the "added" state to whatever button is on screen for that product.
  function paint() {
    var now = Date.now();
    document.querySelectorAll('[data-pp-wl-product]').forEach(function (b) {
      var until = added.get(b.dataset.ppWlProduct);
      var state = b.querySelector('.pp-wl__state');
      if (state) state.classList.toggle('is-added', !!until && until > now);
    });
    added.forEach(function (until, id) {
      if (until <= now) added.delete(id);
    });
  }

  // Scroll progress bar under the row (thumb width = visible share, position = scroll).
  function progress(list) {
    var bar = list.parentElement.querySelector('[data-pp-wl-progress]');
    if (!bar) return;
    var max = list.scrollWidth - list.clientWidth;
    var share = list.scrollWidth ? list.clientWidth / list.scrollWidth : 1;
    bar.style.width = Math.max(share * 100, 12) + '%';
    bar.style.left = (max > 0 ? (list.scrollLeft / max) * (100 - Math.max(share * 100, 12)) : 0) + '%';
    bar.parentElement.style.visibility = max > 0 ? 'visible' : 'hidden';
    // Desktop arrows (12 Oct 2026): grey out at the ends; hide with the bar when there is nothing to scroll.
    list.parentElement.querySelectorAll('[data-pp-wl-arrow]').forEach(function (a) {
      var dir = Number(a.getAttribute('data-pp-wl-arrow'));
      a.disabled = max <= 0 || (dir < 0 ? list.scrollLeft <= 1 : list.scrollLeft >= max - 1);
      a.style.visibility = max > 0 ? 'visible' : 'hidden';
    });
  }
  // Arrow click: move one card (card width + gap). Wheel, drag and swipe scrolling are untouched.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pp-wl-arrow]');
    if (!a) return;
    e.preventDefault();
    var list = a.parentElement.parentElement.querySelector('.pp-wl__list');
    var card = list && list.querySelector('.pp-wl__item');
    if (!list || !card) return;
    var step = card.getBoundingClientRect().width + 12;
    list.scrollBy({ left: Number(a.getAttribute('data-pp-wl-arrow')) * step, behavior: reduced ? 'auto' : 'smooth' });
  });
  function progressAll() {
    document.querySelectorAll('.pp-wl__list').forEach(progress);
  }
  document.addEventListener(
    'scroll',
    function (e) {
      if (e.target.classList && e.target.classList.contains('pp-wl__list')) return progress(e.target);
      // the shopper scrolled the drawer: follow, so a later re-render does not undo their scroll
      if (hold) { var band = document.querySelector('.pp-wl'); if (band) hold.top = band.getBoundingClientRect().top; }
    },
    true
  );
  window.addEventListener('resize', progressAll);

  // New cart lines ease in (fade + slide + soft green highlight) instead of popping in.
  var known = null; // data-keys of the lines already on screen
  function lineRows() {
    return Array.prototype.slice.call(document.querySelectorAll('.cart-drawer__items .cart-items__table-row[data-key]'));
  }
  function easeInNewRows() {
    var rows = lineRows();
    var keys = new Set(rows.map(function (r) { return r.dataset.key; }));
    if (known === null) { known = keys; return; }
    var dialog = document.querySelector('.cart-drawer__dialog');
    rows.forEach(function (r) {
      if (known.has(r.dataset.key) || reduced || !r.animate) return;
      r.animate(
        [
          { opacity: 0, backgroundColor: 'rgba(31,138,60,0.14)' },
          { opacity: 1, backgroundColor: 'rgba(31,138,60,0.14)', offset: 0.45 },
          { opacity: 1, backgroundColor: 'rgba(31,138,60,0)' },
        ],
        { duration: 1100, delay: dialog && dialog.open ? 0 : 280, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' }
      );
    });
    known = keys;
  }
  easeInNewRows();

  new MutationObserver(function () {
    keepBand();
    easeInNewRows();
    if (added.size) paint();
    progressAll();
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-pp-wl-select]');
    if (!select) return;
    var price = select.closest('.pp-wl__item').querySelector('[data-pp-wl-price]');
    var opt = select.options[select.selectedIndex];
    var was = select.closest('.pp-wl__item').querySelector('[data-pp-wl-was]');
    if (price && opt) price.textContent = opt.dataset.price;
    if (was && opt) was.textContent = opt.dataset.was;
  });

  document.addEventListener('click', async function (e) {
    var btn = e.target.closest('[data-pp-wl-add]');
    if (!btn) return;
    e.preventDefault();

    var item = btn.closest('.pp-wl__item');
    var select = item ? item.querySelector('[data-pp-wl-select]') : null;
    var variantId = select ? select.value : btn.dataset.ppWlAdd;
    var productId = btn.dataset.ppWlProduct;
    var component = btn.closest('cart-items-component');
    var sectionId = component ? component.dataset.sectionId : null;
    var t0 = Date.now();
    // tick straight away: the tap is acknowledged before anything else happens
    added.set(productId, t0 + ADDED_MS);
    paint();
    btn.setAttribute('aria-busy', 'true');

    try {
      var body = { items: [{ id: Number(variantId), quantity: 1 }] };
      if (sectionId) body.sections = sectionId;
      var addRes = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      var result = await addRes.json();
      if (!addRes.ok) throw new Error(result.description || 'Could not add to cart');

      btn.removeAttribute('aria-busy');
      setTimeout(paint, ADDED_MS + 50);

      var cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
      // let the shopper see the tick before the cart changes
      var wait = reduced ? 0 : MIN_TICK_MS - (Date.now() - t0);
      if (wait > 0) await new Promise(function (r) { setTimeout(r, wait); });
      holdBand();
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'pp-wetline-upsell',
            data: {
              source: 'pp-wetline-upsell',
              itemCount: cart.item_count,
              variantId: variantId,
              sections: result.sections,
            },
          },
        })
      );
      keepBand();
    } catch (err) {
      btn.removeAttribute('aria-busy');
      added.delete(productId);
      paint();
      console.error('[Wet Line upsell]', err);
    }
  });
})();
